import { Link } from 'react-router-dom';

/**
 * Minimal site footer. Rendered once at the App shell level so every page
 * includes it. Links are intentionally spare — we're a hobby project, not
 * a sprawling corporate site.
 *
 * Terms and Privacy currently 404 — those pages come in Tier 4C. The links
 * are in place so we don't have to re-visit this file when we add them.
 *
 * GitHub link is a placeholder to the owner's GitHub profile for now; swap
 * to the project repo when it has a public home.
 */
export function Footer() {
  const year = new Date().getUTCFullYear();
  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <div className="app-footer-links">
          <Link to="/terms">Terms</Link>
          <span className="app-footer-sep">·</span>
          <Link to="/privacy">Privacy</Link>
          <span className="app-footer-sep">·</span>
          <a href="https://github.com/murphylee10" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
        </div>
        <div className="app-footer-copy">© {year} FlareCode</div>
      </div>
    </footer>
  );
}
